import { ScalesIcon, WarningIcon, ShieldWarningIcon, InfoIcon } from "@phosphor-icons/react";

const Section = ({ icon: Icon, title, tone = "white", children }) => {
  const toneCls = tone === "danger" ? "text-danger" : tone === "gold" ? "text-[#F0C000]" : "text-white";
  return (
    <section className="border border-white/10 bg-card p-5 space-y-2">
      <div className="flex items-center gap-2">
        <Icon size={18} weight="fill" className={toneCls} />
        <h2 className={`font-heading font-bold text-base ${toneCls}`}>{title}</h2>
      </div>
      <div className="text-sm text-muted-foreground leading-relaxed space-y-2">{children}</div>
    </section>
  );
};

export default function Disclaimer() {
  return (
    <div className="max-w-[900px] mx-auto px-4 sm:px-6 py-6 space-y-6 animate-fade-up" data-testid="disclaimer-page">
      <div>
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 flex items-center justify-center bg-neon text-black"><ScalesIcon size={24} weight="bold" /></div>
          <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tighter leading-none">DISCLAIMER</h1>
        </div>
        <p className="text-muted-foreground mt-3 text-sm">AlphaApeing is a research & analytics tool. Please read this before using wallet tracking or acting on anything you see here.</p>
      </div>

      <Section icon={WarningIcon} title="Not financial advice" tone="danger">
        <p>
          Nothing on AlphaApeing is financial, investment, legal or tax advice. All data, scores, tags, and wallet lists are provided for
          <span className="text-white"> educational and analytical purposes only</span>. Meme coins are extremely high-risk and speculative —
          most go to zero. Rugs, honeypots and coordinated dumps are common. Only risk capital you can afford to lose entirely, and always
          do your own research (DYOR) and verify everything on-chain yourself.
        </p>
      </Section>

      <Section icon={InfoIcon} title="No guarantee of wallet ownership" tone="gold">
        <p>
          Wallet-to-identity associations shown on this site (e.g. a name or handle attached to an address) are based on
          <span className="text-white"> publicly-available information and on-chain heuristics</span>. They <span className="text-white">cannot be 100% verified</span>
          unless the individual has publicly disclosed the wallet themselves. We do not perform de-anonymization of private/stealth wallets.
          Names and handles may be inaccurate, outdated, or refer to different people. Do not treat any label as confirmed fact.
        </p>
      </Section>

      <Section icon={ShieldWarningIcon} title="The copy-trading trap">
        <p>
          Following or copy-trading KOL / “smart money” wallets is <span className="text-white">not a reliable strategy</span>. KOLs and insiders frequently:
        </p>
        <ul className="space-y-1.5 pl-1">
          <li className="flex gap-2"><span className="text-danger shrink-0">•</span><span>use <span className="text-white">wash trading</span> to fake volume and momentum;</span></li>
          <li className="flex gap-2"><span className="text-danger shrink-0">•</span><span>receive free tokens directly from developers, then pump-and-dump on their audience;</span></li>
          <li className="flex gap-2"><span className="text-danger shrink-0">•</span><span>operate <span className="text-white">multiple undisclosed wallets</span> to hedge or hide their real positions.</span></li>
        </ul>
        <p>Following any wallet blindly usually results in retail traders losing money. Alerts and tags on this site are signals to research — never buy instructions.</p>
      </Section>

      <Section icon={InfoIcon} title="Privacy & wallet removal">
        <p>
          A standalone public wallet address is visible to anyone on an open ledger. If you are an influencer, developer or wallet owner and
          would like your <span className="text-white">name/handle untagged</span> or your wallet removed from our curated lists, use the
          <span className="text-white"> “Request removal” form on the Creators → Playbook page</span>. Requests are
          <span className="text-white"> auto-hidden immediately</span> upon submission, pending review. We honor legitimate removal requests promptly.
        </p>
      </Section>

      <Section icon={InfoIcon} title="Data & liability">
        <p>
          Market data is aggregated from third-party sources (DexScreener, GeckoTerminal, RugCheck, PumpPortal and others) and may be delayed,
          incomplete or inaccurate. AlphaApeing makes no warranties and accepts no liability for any loss arising from use of this site or
          reliance on its data. Use at your own risk.
        </p>
      </Section>

      <p className="text-xs font-mono text-muted-foreground/70 text-center pt-2">ALPHAAPEING · Research tool, not financial advice · DYOR before aping</p>
    </div>
  );
}
